import { connect } from 'react-redux';
import { expandAndFocusCommentPanel } from '../../../DeviationPage/redux/actions';
const mapDispatchToProps = {
    onToggleCommentPanel: expandAndFocusCommentPanel
};
export default connect(undefined, mapDispatchToProps);

//# sourceMappingURL=CommentButton.container.js.map